import { nanoid } from 'nanoid';
import { useEffect, useRef } from 'react';
import { useMap } from 'react-map-gl/mapbox';
import { subscribe, useSnapshot } from 'valtio';
import SurfaceCanvas from '~/components2/Map/canvas/Surface';
import { mapState } from '~/components2/Map/Map';
import store from '../drawStore';

export default function Surface() {
  const { current: map } = useMap();
  const { objectsAsArray } = useSnapshot(store) as typeof store;
  const container = useRef<HTMLDivElement>(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: surface is created once for the map instance
  useEffect(() => {
    if (container.current && map) {
      const surface = new SurfaceCanvas({
        id: `sub-geometry-surface-${nanoid()}`,
        container: container.current,
        map: map.getMap(),
        store,
      });
      const unsubscribe = subscribe(mapState, () => surface.refreshScreenCoords());
      return () => {
        unsubscribe();
        surface.destroy();
      };
    }
  }, []);

  if (!map) return null;

  return (
    <div
      id="sub-geometry-surface-container"
      style={{ cursor: '-moz-grab' }}
      className={`absolute left-0 top-0 ${objectsAsArray.length > 0 ? 'visible' : 'hidden'}`}
      ref={container}
    />
  );
}
